<div class="sitemap-header" *ngIf="siteMap$ | async as siteMap">
  <div class="link-group" *ngFor="let page of siteMap[0].subpages">
    <a href [fragment]="page.link | fragment" [routerLink]="page.link | fragment: false">{{ page.name }}</a>
    <a
      *ngFor="let subpage of page.subpages"
      href
      [fragment]="subpage.link | fragment"
      [routerLink]="subpage.link | fragment: false"
    >
      {{ subpage.name }}
    </a>
  </div>
</div>
